import React, { useEffect, useState } from 'react'
// import { Link, useParams } from "react-router-dom";
import { withRouter } from "../hooks/withRouter"
import { getPersonaDetalle } from '../api/consultaVehicularApi';
// import queryString from "query-string";
// import { getPersonaVehicular } from '../api/consultaVehicularApi';
import { Link } from "react-router-dom";
import { UseAuth } from "../hooks/useAuth";



function BusquedaDetalles(props) {
    const { location } = props.router;

    const [result, setResult] = useState([])
    const url = location.pathname.split("/")
    const id = url[2]
    const { accessToken } = UseAuth();
    useEffect(() => {
        getPersonaDetalle(accessToken, id).then((response) => {
            if (response?.code !== 200) {

                setResult(response)
            } else {
            }
        }).catch(() => {


         });


    }, [accessToken, id]);
    const formatDate = (date) => {
        if (!date) return ""; // Manejar fechas nulas o indefinidas

        // Convertir la fecha a un objeto Date
        const formattedDate = new Date(date);

        // Obtener el día, mes y año
        const day = formattedDate.getDate();
        const month = formattedDate.getMonth() + 1; // Los meses en JavaScript son indexados desde 0
        const year = formattedDate.getFullYear();

        // Formatear la fecha en el formato "DD/MM/AAAA"
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    };


    if (result.length < 1) {
        return "loading"
    }

    return (
        <>
            <div>
                <div className='top-bar2'>
                    <div className="top-bar">

                        <div className="logo">
                            {/* Botón con apariencia de logo que lleva a la página principal */}
                            <Link to="/">
                                <button className="logo-button">
                                    <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div class="acta-container">
                            <h1>Padron Vehicular</h1>
                {result.map((res, index) => (
                    <div key={index}>
                        <h1>{res.nombre}</h1>
                        <div className="acta" >
                            <div className='column'>

                                <h1>TELEFONO:  </h1>
                                <p className="letra">{res.telefono}</p>
                                <h1>DIRECCION:  </h1>
                                <p className="letra">{res.direccion}</p>
                                <h1>PLACA: </h1>
                                <p className="letra">{res.folio} </p>


                            </div>
                            <div className='column'>
                                <h1>NUMERO DE SERIE: </h1>
                                <p className="letra">{res.numero_serie} </p>
                                <h1>NUMERO DE MOTOR:</h1>
                                <p className="letra"> {res.numero_motor} </p>
                                <h1>MARCA:</h1>
                                <p className="letra"> {res.marca} </p>
                                <h1>LINEA:</h1>
                                <p className="letra">{res.linea} </p>
                                <h1>COLOR:</h1>
                                <p className="letra"> {res.color} </p>


                            </div>
                            <div className='column'>
                                <h1>TIPO DE VEHICULO: </h1>
                                <p className="letra">{res.tipo_vehiculo}</p>
                                <h1>FECHA DE ALTA: </h1>
                                <p className="letra">{formatDate(res.fecha_alta)}</p>
                                <h1>FECHA DE BAJA:</h1>
                                <p className="letra"> {res.fecha_baja}</p>
                                <h1>FECHA DE INICIO DE OBLIGACIONES: </h1>
                                <p className="letra">{formatDate(res.inicio_obligaciones)}</p>

                                <h1> PLACA ANTERIOR: </h1>
                                <p className="letra">{res.IMANOL}</p>



                            </div>


                            </div>

                        </div>

                ))}
                </div>
            </div>
        </>

    )
}

export default withRouter(BusquedaDetalles)
